import { createContext, useContext } from "react";
import { Link } from "../api/api";

type Rolle = "VIRKSOMHET" | "PARTNERONBOARDING";

export interface PartnerOnboardingParams {
  partnerId: number;
  redirectUrl: string;
  nonce: string;
  organization: string;
}

export interface Entrypoint {
  rolle?: Rolle;
  partnerOnboardingParams?: PartnerOnboardingParams;
  _links: Array<Link>;
}

export const EntrypointContext = createContext<Entrypoint | null>(null);

//lager en hook, for å slippe å null-checke contexten der den brukes.
export const useEntrypointContext = () => {
  const entrypointContext = useContext(EntrypointContext);

  if (!entrypointContext) {
    throw new Error("context ikke satt");
  }

  return entrypointContext;
};
